// extracted by mini-css-extract-plugin
module.exports = {"BooksMenu":"BooksMenu_BooksMenu__2a-ZG","BooksMenu__MenuDetail":"BooksMenu_BooksMenu__MenuDetail__1c6oX","BooksMenu__Time":"BooksMenu_BooksMenu__Time__1aGxS"};